<template>
  <v-container>
    <v-row v-if="notification && notification.formatted">
      <v-col cols="4" class="pt-0">
        <v-row>
          <v-col class="text-h5">
            Expert Analysis &amp; Outlooks
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field
              :value="notification.formatted.name"
              label="Alert Name"
              :error-messages="errorMessageName"
              class="pt-0"
              :maxlength="75"
              :disabled="readOnly"
              @input="handleChangeName"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-radio-group
              :value="notification.formatted.docType"
              label="Expert Analysis &amp; Outlook types"
              class="mt-0 pt-0"
              :disabled="readOnly"
              @change="handleChangeBriefingType"
            >
              <v-radio
                v-for="item in briefingTypes"
                :key="item.value"
                :label="item.text"
                :value="item.value"
              ></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="1"></v-col>
      <v-col>
        <span class="text-h6">{{ briefingTypeTitle }}</span>

        <NotificationsBriefingsCountryAnalysis
          v-if="notification.formatted.docType === typeCountryAnalysis"
          :read-only="readOnly"
        ></NotificationsBriefingsCountryAnalysis>
        <NotificationsBriefingsCalendarEvents
          v-if="notification.formatted.docType === typeCalendarEvents"
          :read-only="readOnly"
        ></NotificationsBriefingsCalendarEvents>
        <NotificationsBriefingsElectionsWatch
          v-if="notification.formatted.docType === typeElectionWatch"
          :read-only="readOnly"
        ></NotificationsBriefingsElectionsWatch>
        <NotificationsBriefingsRegionalOutlook
          v-if="notification.formatted.docType === typeRegionalOutlook"
          :read-only="readOnly"
        >
        </NotificationsBriefingsRegionalOutlook>
        <NotificationsBriefingsCyber
          v-if="
            notification.formatted.docType === typeCyberWeekly ||
            notification.formatted.docType === typeCyberMonthly
          "
          :type="notification.formatted.docType"
        >
        </NotificationsBriefingsCyber>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import lodashGet from "lodash/get";
import lodashFind from "lodash/find";
import lodashCloneDeep from "lodash/cloneDeep";
import lodashRemove from "lodash/remove";

import { MODULE_PREFIX_NOTIFICATIONS } from "@/store";
import { GET_NOTIFICATION } from "@/store/actions.type";
import { mapGetters } from "vuex";
import {
  NOTIFICATION_BRIEFING_TYPES,
  NOTIFICATION_BRIEFING_TYPE_COUNTRY_ANALYSIS,
  NOTIFICATION_BRIEFING_TYPE_ELECTION_WATCH,
  NOTIFICATION_BRIEFING_TYPE_CALENDAR_EVENTS,
  NOTIFICATION_BRIEFING_TYPE_REGIONAL_OUTLOOK,
  NOTIFICATION_BRIEFING_TYPE_CYBER_WEEKLY,
  NOTIFICATION_BRIEFING_TYPE_CYBER_MONTHLY,
} from "@/common/constants/notifications";
import { hasPlusCyberAccess } from "@/services/user/user.service";

export default {
  name: "NotificationsStepBriefings",
  components: {
    NotificationsBriefingsCountryAnalysis: () =>
      import(
        "@/components/notifications/NotificationsBriefingsCountryAnalysis"
      ),
    NotificationsBriefingsCalendarEvents: () =>
      import("@/components/notifications/NotificationsBriefingsCalendarEvents"),
    NotificationsBriefingsElectionsWatch: () =>
      import("@/components/notifications/NotificationsBriefingsElectionsWatch"),
    NotificationsBriefingsRegionalOutlook: () =>
      import(
        "@/components/notifications/NotificationsBriefingsRegionalOutlook"
      ),
    NotificationsBriefingsCyber: () =>
      import("@/components/notifications/NotificationsBriefingsCyber"),
  },
  props: {
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const hasPlusCyber = hasPlusCyberAccess();
    let briefingTypes = lodashCloneDeep(NOTIFICATION_BRIEFING_TYPES);
    if (!hasPlusCyber) {
      briefingTypes = lodashRemove(briefingTypes, (t) => {
        return !t.value.includes("cyber");
      });
    }
    if (!this.featureUnlocked("calendar-events-alerts")) {
      briefingTypes = lodashRemove(briefingTypes, (t) => {
        return t.value !== NOTIFICATION_BRIEFING_TYPE_CALENDAR_EVENTS;
      });
    } else {
      briefingTypes = lodashRemove(briefingTypes, (t) => {
        return t.value !== NOTIFICATION_BRIEFING_TYPE_ELECTION_WATCH;
      });
    }
    return {
      hasPlusCyber: hasPlusCyber,
      briefingTypes: briefingTypes,
      errorMessageName: null,
      typeCountryAnalysis: NOTIFICATION_BRIEFING_TYPE_COUNTRY_ANALYSIS,
      typeCalendarEvents: NOTIFICATION_BRIEFING_TYPE_CALENDAR_EVENTS,
      typeElectionWatch: NOTIFICATION_BRIEFING_TYPE_ELECTION_WATCH,
      typeRegionalOutlook: NOTIFICATION_BRIEFING_TYPE_REGIONAL_OUTLOOK,
      typeCyberWeekly: NOTIFICATION_BRIEFING_TYPE_CYBER_WEEKLY,
      typeCyberMonthly: NOTIFICATION_BRIEFING_TYPE_CYBER_MONTHLY,
    };
  },
  computed: {
    ...mapGetters({
      notification: MODULE_PREFIX_NOTIFICATIONS + "notification",
    }),
    briefingTypeTitle() {
      if (lodashGet(this.notification, "formatted.docType")) {
        const briefingType = lodashFind(this.briefingTypes, [
          "value",
          this.notification.formatted.docType,
        ]);
        if (briefingType && briefingType.text) {
          return briefingType.text;
        }
      }
      return null;
    },
  },
  methods: {
    handleChangeName(value) {
      const notification = lodashCloneDeep(this.notification);
      notification.formatted = notification.formatted || {};
      notification.formatted.name = value;
      this.update(notification);
    },
    handleChangeBriefingType(value) {
      const notification = lodashCloneDeep(this.notification);
      notification.formatted = notification.formatted || {};
      notification.formatted.docType = value;
      notification.formatted.sharedList = [];
      if (lodashGet(notification, "formatted.params.locations")) {
        delete notification.formatted.params.locations;
      }
      this.update(notification);
    },
    update(notification) {
      this.$store.dispatch(
        MODULE_PREFIX_NOTIFICATIONS + GET_NOTIFICATION,
        notification
      );
    },
  },
  watch: {},
};
</script>

<style>
.hyp-types .v-btn-toggle {
  display: flex !important;
  flex-direction: column !important;
}
</style>
<style scoped></style>
